(()=>{
  const lib=window.__2in1FlagLibrary;
  if(!lib)return;
  const {SPORTS,SOCCER_FILES,slug,clubLabel,sportsFile,urlFor,countries}=lib;

  function init(){
    const root=document.querySelector('[data-hfd]');
    if(!root||root.dataset.fastLibraryReady)return;
    root.dataset.fastLibraryReady='1';
    const rows=side=>window.hfdUi?.nodes(root,side||currentSide(),'[data-select-row]')||[...root.querySelectorAll('[data-select-row]')];
    const layers=side=>window.hfdUi?.nodes(root,side||currentSide(),'[data-layer]')||[...root.querySelectorAll('[data-layer]')];
    const currentSide=()=>root.querySelector('[data-side].is-active')?.dataset.side||'front';
    const visitorCountry=(root.dataset.visitorCountry||'us').toLowerCase();
    const sideState={front:null,back:null};
    function willRestoreDesign(){
      if(window.__hfdRestoring)return true;
      try{
        const params=new URLSearchParams(location.search);
        if(params.get('design')||params.get('flags'))return true;
        if(sessionStorage.getItem('2in1flags:open-saved'))return true;
        const draft=JSON.parse(localStorage.getItem('2in1flags:design:draft:v1')||'null');
        return !!(draft?.front&&draft?.back);
      }catch(_){return false;}
    }

    function sportsHtml(){
      const soccerOptions=SOCCER_FILES.map(base=>{const file=`${base}_5000_5500`;return `<option value="${file}" data-file="${file}">${clubLabel(base)}</option>`;}).join('');
      const otherGroups=Object.entries(SPORTS).map(([league,teams])=>{
        const options=teams.map(label=>{const file=sportsFile(league,label);return `<option value="${file}" data-file="${file}">${label}</option>`;}).join('');
        return `<optgroup label="${league}">${options}</optgroup>`;
      }).join('');
      return `<optgroup label="Football Clubs">${soccerOptions}</optgroup>${otherGroups}`;
    }

    function styleImage(el,isIcon=false,isSports=false){
      if(!el)return;
      el.style.background='transparent';
      el.style.padding='0';
      el.style.boxSizing='border-box';
      el.style.transform='none';
      if(isIcon){
        el.style.objectFit=isSports?'contain':'cover';
        el.style.objectPosition='50% 50%';
        el.style.position='';
        el.style.left='';
        el.style.top='';
        el.style.width='';
        el.style.height='';
        return;
      }
      el.style.objectFit='fill';
      el.style.objectPosition='50% 50%';
    }

    function renderRow(row){
      const name=window.hfdUi?.of(row)||currentSide();
      const index=rows(name).indexOf(row);
      if(index<0)return;
      const type=row.querySelector('[data-selection-type]');
      const team=row.querySelector('[data-flag-selection]');
      if(!type||!team||type.value==='upload'||type.value==='my-uploads'||type.value==='text'||!team.value)return;
      const isSports=type.value==='sports';
      const selected=team.selectedOptions?.[0];
      const file=selected?.dataset?.file||(isSports?team.value:slug(selected?.textContent||team.value));
      if(!file)return;
      const url=urlFor(file);
      const img=layers(name)[index]?.querySelector('img');
      const icon=row.querySelector(`[data-select-icon="${index+1}"]`)||root.querySelector(`[data-hfd-side="${name}"] [data-select-icon="${index+1}"]`);
      row.dataset.libraryImage=url;
      row.dataset.librarySports=isSports?'1':'0';
      const useCountryFallback=()=>{
        if(isSports)return;
        const fallback=`https://flagcdn.com/w2560/${team.value}.png`;
        row.dataset.libraryImage=fallback;
        if(img){img.onerror=null;img.src=fallback;styleImage(img,false,false);}
        if(icon){icon.onerror=null;icon.src=fallback;styleImage(icon,true,false);}
        saveSide(name);
        document.dispatchEvent(new CustomEvent('flag:library-rendered'));
      };
      if(img){img.onerror=useCountryFallback;img.src=url;styleImage(img,false,isSports);}
      if(icon){icon.onerror=useCountryFallback;icon.src=url;styleImage(icon,true,isSports);}
    }

    function fillRow(row,preserve=true){
      const type=row.querySelector('[data-selection-type]');
      const team=row.querySelector('[data-flag-selection]');
      if(!type||!team)return;
      if(type.value==='upload'||type.value==='my-uploads'||type.value==='text')return;
      const old=preserve?team.value:'';
      if(type.value==='sports'){
        const html=sportsHtml();
        if(team.innerHTML!==html)team.innerHTML=html;
      }else{
        const html=countries.map(x=>`<option value="${x.value}" data-file="${x.file}">${x.label}</option>`).join('');
        if(team.innerHTML!==html)team.innerHTML=html;
      }
      if(old&&[...team.options].some(x=>x.value===old))team.value=old;
      else if(preserve&&old)team.value=old;
      else if(!preserve){/* caller sets the value after options exist */}
      else if(willRestoreDesign()){/* restore applies the stored items */}
      else if(type.value==='country'&&[...team.options].some(x=>x.value===visitorCountry))team.value=visitorCountry;
      else if(!team.value&&team.options[0])team.selectedIndex=0;
      renderRow(row);
    }

    function snapshotRows(side=currentSide()){return rows(side).map(row=>({type:row.querySelector('[data-selection-type]')?.value||'country',value:row.querySelector('[data-flag-selection]')?.value||'',image:row.dataset.libraryImage||'',sports:row.dataset.librarySports||'0'}));}
    function saveSide(side=currentSide()){sideState[side]=snapshotRows(side);}
    function reflectSelect(select){
      select?.dispatchEvent(new Event('change',{bubbles:true}));
    }
    function applySnapshot(saved,side=currentSide()){
      if(!saved)return;
      window.__hfdApplyingLibrary=true;
      try{
        rows(side).forEach((row,index)=>{
          const state=saved[index];if(!state)return;
          const type=row.querySelector('[data-selection-type]');
          const team=row.querySelector('[data-flag-selection]');
          if(!type||!team)return;
          type.value=state.type||'country';fillRow(row,false);
          if(state.value&&[...team.options].some(option=>option.value===state.value))team.value=state.value;
          renderRow(row);
          reflectSelect(type);
          reflectSelect(team);
        });
      }finally{
        window.__hfdApplyingLibrary=false;
      }
    }
    function matchOptionValue(select,wanted){
      const options=[...select.options];
      const value=String(wanted||'');
      if(!value)return '';
      const exact=options.find(option=>option.value===value);
      if(exact)return exact.value;
      const withSuffix=options.find(option=>option.value===`${value}_5000_5500`);
      if(withSuffix)return withSuffix.value;
      const stripped=value.replace(/_5000_5500$/,'');
      return options.find(option=>option.value.replace(/_5000_5500$/,'')===stripped)?.value||'';
    }
    function applyItems(items,side=currentSide()){
      window.__hfdApplyingLibrary=true;
      try{
        rows(side).forEach((row,index)=>{
          const item=items[index];if(!item)return;
          const type=row.querySelector('[data-selection-type]');
          const team=row.querySelector('[data-flag-selection]');
          if(!type||!team)return;
          const wantedType=item.type||'country';
          type.value=wantedType;
          if(wantedType==='text'){reflectSelect(type);return;}
          if(wantedType!=='upload'&&wantedType!=='my-uploads'){
            fillRow(row,false);
            const found=matchOptionValue(team,item.value);
            if(found)team.value=found;
            renderRow(row);
          }
          reflectSelect(type);
          reflectSelect(team);
        });
        saveSide(side);document.dispatchEvent(new CustomEvent('flag:library-rendered'));
      }finally{
        window.__hfdApplyingLibrary=false;
      }
    }
    window.hfdApplyLibraryItems=applyItems;
    function restoreAll(side=currentSide()){
      rows(side).forEach((row,index)=>{
        const type=row.querySelector('[data-selection-type]')?.value;
        if(type==='upload'||type==='my-uploads'||type==='text')return;
        const url=row.dataset.libraryImage;if(!url)return;
        const isSports=row.dataset.librarySports==='1';
        const img=layers(side)[index]?.querySelector('img');
        const icon=row.querySelector(`[data-select-icon="${index+1}"]`);
        if(img){img.src=url;styleImage(img,false,isSports);}
        if(icon){icon.src=url;styleImage(icon,true,isSports);}
      });
      document.dispatchEvent(new CustomEvent('flag:library-rendered'));
    }

    ['front','back'].forEach(name=>rows(name).forEach(row=>fillRow(row,true)));
    sideState.front=snapshotRows('front').map(x=>({...x}));
    sideState.back=snapshotRows('back').map(x=>({...x}));
    root.addEventListener('change',e=>{
      const row=e.target.closest?.('[data-select-row]');
      if(!row||!e.target.matches('[data-selection-type],[data-flag-selection]'))return;
      if(window.__hfdApplyingLibrary)return;
      const name=window.hfdUi?.of(row)||currentSide();
      if(e.target.matches('[data-selection-type]'))fillRow(row,false);else renderRow(row);
      saveSide(name);document.dispatchEvent(new CustomEvent('flag:library-rendered'));document.dispatchEvent(new CustomEvent('flag:design-change',{detail:{source:'library',side:name}}));
    },true);
    root.addEventListener('click',e=>{
      if(e.target.closest('[data-side],[data-mode]'))return;
      const preserve=e.target.closest('[data-count]');if(!preserve)return;
      const activeSide=window.hfdUi?.of(preserve)||currentSide();saveSide(activeSide);requestAnimationFrame(()=>requestAnimationFrame(()=>{applySnapshot(sideState[activeSide],activeSide);restoreAll(activeSide);}));
    },true);
    root.addEventListener('click',e=>{const target=e.target.closest('[data-reset-side],[data-reset],[data-flag-reset],[data-cross]');if(!target)return;requestAnimationFrame(()=>requestAnimationFrame(()=>{const name=target.dataset.resetSide||window.hfdUi?.of(target)||currentSide();saveSide(name);restoreAll(name);}));});
    document.addEventListener('flag:order-change',e=>{const detail=e.detail||{};const name=detail.side||currentSide();if(Array.isArray(detail.items))applyItems(detail.items,name);});
    document.addEventListener('flag:sides-swapped',()=>{
      const next=sideState.front;
      sideState.front=sideState.back;
      sideState.back=next;
      requestAnimationFrame(()=>{
        applySnapshot(sideState.front,'front');
        applySnapshot(sideState.back,'back');
        restoreAll('front');
        restoreAll('back');
      });
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
})();
